import React from 'react';
import { Copy } from 'lucide-react';
export const HeroSection = ({
  onClaimCode
}) => {
  return <section className="mt-4 mb-8" data-id="element-139">
      <div className="bg-gray-900 text-white rounded-xl p-6 relative overflow-hidden" data-id="element-140">
        <div className="absolute top-4 right-4 bg-white text-gray-900 text-xs font-medium px-2 py-1 rounded-full" data-id="element-141">
          Featured Deal
        </div>
        <h2 className="text-2xl font-bold mt-4" data-id="element-142">Up to 20% Off</h2>
        <p className="text-gray-300 mt-1 mb-4" data-id="element-143">
          Save big on your favorite brands today
        </p>
        <button onClick={() => onClaimCode({
        code: 'SAVE20',
        brand: 'Featured'
      })} className="flex items-center bg-white text-gray-900 px-4 py-2 rounded-lg font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300" data-id="element-144">
          <Copy size={16} className="mr-2" data-id="element-145" />
          Claim Code
        </button>
      </div>
    </section>;
};